export default function Excel_Training() {
  return <div>Excel_Training</div>;
}
